"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Analytics {
    static getInstance() {
        if (!Analytics._instance) {
            Analytics._instance = new Analytics();
        }
        return Analytics._instance;
    }
    initialize(mixpanelProjectToken, name = 'main', config = {}) {
        const disableAnalytics = new URLSearchParams(window.location.search).has('_disableAnalytics');
    }
    track(eventName, data) {
    }
    identify(email, profile) {
    }
    trackWithCategory(category, eventName, data) {
        this.track(eventName, { ...data, Category: category });
    }
    timeEvent(eventName) {
    }
}
Analytics._globallyDisableAnalytics = true;
exports.default = Analytics;
